import ExternalLink, { ExternalLinkProps } from './ExternalLink';

export default ExternalLink;

export { ExternalLinkProps };
